<template>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d640.6451154633289!2d44.4757267153838!3d40.19929849918891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd7abdcc86fb%3A0x42c5e5d7e5df34ad!2s4%20Building%2C%206%20Abelian%20St%2C%20Yerevan%200038!5e0!3m2!1sen!2sam!4v1711695071411!5m2!1sen!2sam"
            width="100%"
            height="464"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            sandbox="allow-scripts allow-same-origin allow-popups">
    </iframe>
</template>

